import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Container, Row,
} from 'reactstrap';
import { Redirect } from 'react-router-dom';
import { withTranslation } from 'react-i18next';
import StockDisplay from './components/StockDisplay';

class UserLists extends Component {
  static propTypes = {
    match: PropTypes.shape({
      params: PropTypes.shape({
        inventorytype: PropTypes.string,
      }).isRequired,
    }).isRequired,
  }

  constructor(props) {
    super(props);
    this.userData = JSON.parse(localStorage.getItem('userData'));
    const { match } = this.props;
    const { params } = match;

    this.state = {
      proparams: params,
    };
  }

  render() {
    const { proparams } = this.state;
    if (this.userData.location_id !== proparams.locationid && ((['1', '5', '6'].indexOf(this.userData.type) > -1) === false)) {
      return (<Redirect to="/dashboard" />);
    }

    return (
      <Container>
        <Row>
          <StockDisplay locationid={proparams.locationid} pagetype={proparams.pageview} viewtype={proparams.type} />
        </Row>
      </Container>
    );
  }
}

export default withTranslation('common')(UserLists);
